export { DetailsProvider, useDetailsContext } from './DetailsProvider'
